import { TServerDefectivesDB, TServerDefectivesDBLockedBy, TServerDefectivesStore } from '@monorepo/types';
import { Action } from '@ngrx/store';

export enum ServerDefectivesStoreActionTypes {
  AcquireLockAndThenInitServerDefectives = 'AcquireLockAndThenInitServerDefectives',
  InitServerDefectivesAndThenReleaseLock = 'InitServerDefectivesAndThenReleaseLock',
  SetServerDefectivesDBAndReleaseLockAndThenInitMasterdataListAndClientDB = 'SetServerDefectivesDBAndReleaseLockAndThenInitMasterdataListAndClientDB',
  SetServerDefectivesDBAndReleaseLockAndThenEmitForServerImagesBackFill = 'SetServerDefectivesDBAndReleaseLockAndThenEmitForServerImagesBackFill',
  ReleaseLockAndThenShowErrorAndThenDismissLoader = 'ReleaseLockAndThenShowErrorAndThenDismissLoader',
  ReleaseLock = 'ReleaseLock',
  SetServerDefectivesDBAndReleaseLockAndThenDismissLoader = 'SetServerDefectivesDBAndReleaseLockAndThenDismissLoader',
  AcquireLockAndThenLoadServerDefectives = 'AcquireLockAndThenLoadServerDefectives',
  LoadServerDefectivesAndThenReleaseLock = 'LoadServerDefectivesAndThenReleaseLock',
  UpdateServerDefectivesStoreLockDetails = 'UpdateServerDefectivesStoreLockDetails',
  ServerDefectivesNoAction = 'ServerDefectivesNoAction',
}

export class AcquireLockAndThenInitServerDefectives implements Action {
  readonly type = ServerDefectivesStoreActionTypes.AcquireLockAndThenInitServerDefectives;
  constructor(public lockFor: TServerDefectivesDBLockedBy) {}
}

export class InitServerDefectivesAndThenReleaseLock implements Action {
  readonly type = ServerDefectivesStoreActionTypes.InitServerDefectivesAndThenReleaseLock;
  constructor(public lockedBy: TServerDefectivesDBLockedBy) {}
}

export class SetServerDefectivesDBAndReleaseLockAndThenInitMasterdataListAndClientDB implements Action {
  readonly type =
    ServerDefectivesStoreActionTypes.SetServerDefectivesDBAndReleaseLockAndThenInitMasterdataListAndClientDB;
  constructor(public lockedBy: TServerDefectivesDBLockedBy, public serverDefectivesDB: TServerDefectivesDB) {}
}

export class SetServerDefectivesDBAndReleaseLockAndThenEmitForServerImagesBackFill implements Action {
  readonly type =
    ServerDefectivesStoreActionTypes.SetServerDefectivesDBAndReleaseLockAndThenEmitForServerImagesBackFill;
  constructor(public lockedBy: TServerDefectivesDBLockedBy, public serverDefectivesDB: TServerDefectivesDB) {}
}

export class SetServerDefectivesDBAndReleaseLockAndThenDismissLoader implements Action {
  readonly type = ServerDefectivesStoreActionTypes.SetServerDefectivesDBAndReleaseLockAndThenDismissLoader;
  constructor(public lockedBy: TServerDefectivesDBLockedBy, public serverDefectivesDB: TServerDefectivesDB) {}
}

export class ReleaseLockAndThenShowErrorAndThenDismissLoader implements Action {
  readonly type = ServerDefectivesStoreActionTypes.ReleaseLockAndThenShowErrorAndThenDismissLoader;
  constructor(public lockedBy: TServerDefectivesDBLockedBy, public title: string, public message: string) {}
}

export class ReleaseLock implements Action {
  readonly type = ServerDefectivesStoreActionTypes.ReleaseLock;
  constructor(public lockedBy: TServerDefectivesDBLockedBy) {}
}

export class AcquireLockAndThenLoadServerDefectives implements Action {
  readonly type = ServerDefectivesStoreActionTypes.AcquireLockAndThenLoadServerDefectives;
  constructor(public lockFor: TServerDefectivesDBLockedBy, public loadWithoutLoader: boolean) {}
}

export class LoadServerDefectivesAndThenReleaseLock implements Action {
  readonly type = ServerDefectivesStoreActionTypes.LoadServerDefectivesAndThenReleaseLock;
  constructor(public lockedBy: TServerDefectivesDBLockedBy, public loadWithoutLoader: boolean) {}
}

export class UpdateServerDefectivesStoreLockDetails implements Action {
  readonly type = ServerDefectivesStoreActionTypes.UpdateServerDefectivesStoreLockDetails;
  constructor(public lockDetails: TServerDefectivesStore['lockDetails']) {}
}

export class ServerDefectivesNoAction implements Action {
  readonly type = ServerDefectivesStoreActionTypes.ServerDefectivesNoAction;
  constructor() {}
}

export type TServerDefectivesActions =
  | AcquireLockAndThenInitServerDefectives
  | InitServerDefectivesAndThenReleaseLock
  | AcquireLockAndThenLoadServerDefectives
  | LoadServerDefectivesAndThenReleaseLock
  | UpdateServerDefectivesStoreLockDetails
  | ReleaseLockAndThenShowErrorAndThenDismissLoader
  | ReleaseLock
  | SetServerDefectivesDBAndReleaseLockAndThenInitMasterdataListAndClientDB
  | SetServerDefectivesDBAndReleaseLockAndThenEmitForServerImagesBackFill
  | SetServerDefectivesDBAndReleaseLockAndThenDismissLoader;
